import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

/*!*******************************************************************************!
  !*** INTEREST/FLOATING RATE API CONFIG                                                       ***!
  \*******************************************************************************/
export const apiConfig = {
  Floatingrates: BOM.baseUrl("floatingrates"),
};

/*!*******************************************************************************!
  !*** INTEREST/FLOATING RATE LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  floatingRateName: "Floating Rate Name",
  floatingRateDetail: "Floating Rate Detail",
  createdBy: "Created By",
  isBaseLendingRate: "Is Base Rate?",
  active: "Active",
  status: "Status",
  newFloatingRate: "New Floating Rate",
  manageFloatingRate: "Manage Floating Rate",
  editFloatingRate: "Edit Floating Rate",
  generalInfo: "General Information",
  floatingRatePeriodInfo: "Floating Rate Period Information",
  floatingRateSetup: "Floating Rate Setup",
  fromDate: "From Date",
  floatingRate: "Floating Rate",
  isDifferential: "Is Differential?",
  action: "Action",
  addFloatingPeriod: "Add Floating Period",
  newFloatingRateMsg: "Floating Rate was successfully created",
  floatingRateId: "Floating Rate Id",
};

/*!***************************************************************************!*\
!*** Floating RATE STATIC CONFIG                                             ***!
\*******************************************************************************/
export const staticConfig = {
  manageFloatingRateItems: [{ title: labelConfig.manageFloatingRate }],
  detailFloatingRateItems: [
    { title: <Link to="/prd0605">{labelConfig.manageFloatingRate}</Link> },
    { title: labelConfig.floatingRateDetail },
  ],
  newFloatingRateItems: [
    { title: <Link to="/prd0605">{labelConfig.manageFloatingRate}</Link> },
    { title: labelConfig.newFloatingRate },
  ],
  editFloatingRateItems: [
    { title: <Link to="/prd0605">{labelConfig.manageFloatingRate}</Link> },
    { title: labelConfig.editFloatingRate },
  ],
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  viewFloatingRateItems: [{ title: labelConfig.floatingRate }],
   viewFloatingRateBreadCrumbItems: [
    { title: <Link to="/view-interest-rate">{labelConfig.floatingRate}</Link> },
    { title: labelConfig.floatingRateDetail },
  ],
  
};

